<template>
  <div class="main">
    <div class="teacher-mod">
      <div class="tit-mod-secs clearfix" style="height: auto">
        <h3 class="fl font-s16">全国授权机构</h3>
        <a href="/sqjg" class="more2 font-s14" target="_blank">查看更多&gt;</a>
      </div>
      <div class="blank20"></div>
      <div class="region-a-list">
        <a
          @click="changeList(index)"
          v-for="(item, index) in areaName"
          :key="index"
          :data-id="index"
          :data-name="item"
          class="region-a" :class="currentArea == index ? 'region-active' : ''"
          >{{ item }}</a
        >
      </div>
      <div class="blank20"></div>
      <div class="pic-list">
        <div v-for="(item, index) in arr" :key="index">
          <div
            class="pic"
            :class="`area_${item.area}`"
            v-show="currentArea == item.area"
          >
            <img :src="item.image" />
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    arr: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    areaName() {
      return this.arr[0]["region"];
    },
  },
  data() {
    return {
      currentArea: 0,
    };
  },
  created() {},
  mounted() {
    let areaIds = Object.keys(this.areaName);
    this.currentArea = areaIds[0] ? areaIds[0] : 0;
  },
  methods: {
    changeList: function (areaId) {
      this.currentArea = areaId;
    },
  },
};
</script>
<style lang="scss" scoped>
a,
a:link {
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  color: #04407d;
}
.region-a-list {
  a.region-a {
    display: inline-block;
    border: 1px solid #04407d;
    padding: 10px;
    color: #04407d;
    font-weight: bold;
    margin:10px 10px 0 0;
  }
  a.region-active{
    background: #04407d;
    color: #fff;
  }
}

.pic-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  .pic {
    width: 228px;
    margin: 0 10px 20px 0;
    img {
      width: 221px;
      height: 136px;
      border: 1px solid #ddd;
      padding: 2px;
    }
    .name {
      width: 225px;
      padding-top: 10px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
